export default __webpack_public_path__ + "static/media/loadingMundi.1abc5a81.gif";